import type { Subscription } from '../../types';
import { isMarketplace as isModernSubscriptionMarketplace } from '../modernSubscription/isMarketplace';

import { isModernSubscription } from './isModernSubscription';

export function isMarketplace(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernSubscriptionMarketplace(subscription);
  }

  return false;
}
